import api from 'services/api/microfwk';
import _ from 'lodash';
import Utils from 'utils/Utils';

export const getUserSeen = (params = {}) =>
  api
    .get('/services/user/seen', {
      params,
    })
    .then(({ data }) => data)
    .catch(error => {
      const data = _.get(error, 'response.data', false);
      if (data) return data;
      return error;
    });

export const getUserSeenDel = (params = {}) =>
  api
    .get('/services/user/seendel', {
      params,
    })
    .then(({ data }) => {
      localStorage.setItem('lasttouch', data?.lasttouch?.seen);
      return data;
    })
    .catch(error => {
      const data = _.get(error, 'response.data', false);
      if (data) return data;
      return error;
    });
